export default "<div>Last Update {{ searchDate | date: 'dd/MM/yyyy HH:mm:ss'}}</div>\n";